import {createAsyncThunk} from '@reduxjs/toolkit'
import {productRulesApi} from './productRulesApi'

// Product Groups
export const fetchProductGroups = createAsyncThunk(
  'productRules/fetchProductGroups',
  async ({client}, {rejectWithValue}) => {
    try {
      return await productRulesApi.getProductGroups(client)
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message || err)
    }
  },
)

export const createProductGroup = createAsyncThunk(
  'productRules/createProductGroup',
  async ({client, payload}, {rejectWithValue}) => {
    try {
      return await productRulesApi.createProductGroup(client, payload)
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message || err)
    }
  },
)

export const deleteProductGroup = createAsyncThunk(
  'productRules/deleteProductGroup',
  async ({client, groupName}, {rejectWithValue}) => {
    try {
      await productRulesApi.deleteProductGroup(client, groupName)
      return groupName
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message || err)
    }
  },
)

export const addPlanCodeThunk = createAsyncThunk(
  'productRules/addPlanCode',
  async ({client, groupName, code}, {rejectWithValue}) => {
    try {
      return await productRulesApi.addPlanCode(client, groupName, code)
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message || err)
    }
  },
)

export const updatePlanCodeThunk = createAsyncThunk(
  'productRules/updatePlanCode',
  async ({client, groupName, oldCode, newCode}, {rejectWithValue}) => {
    try {
      await productRulesApi.updatePlanCode(client, groupName, oldCode, newCode)
      return {groupName, oldCode, newCode}
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message || err)
    }
  },
)

export const deletePlanCodeThunk = createAsyncThunk(
  'productRules/deletePlanCode',
  async ({client, groupName, code}, {rejectWithValue}) => {
    try {
      await productRulesApi.deletePlanCode(client, groupName, code)
      return {groupName, code}
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message || err)
    }
  },
)

// Service ID Rules

export const fetchServiceIdRules = createAsyncThunk(
  'productRules/fetchServiceIdRules',
  async ({client, filters}, {rejectWithValue}) => {
    try {
      const res = await productRulesApi.getServiceIdRules(client, filters)
      return res
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message || err)
    }
  },
)

export const createServiceIdRule = createAsyncThunk(
  'productRules/createServiceIdRule',
  async ({client, payload}, {rejectWithValue}) => {
    try {
      return await productRulesApi.createServiceIdRule(client, payload)
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message || err)
    }
  },
)

export const updateServiceIdRuleThunk = createAsyncThunk(
  'productRules/updateServiceIdRule',
  async ({client, data}, {rejectWithValue}) => {
    try {
      return await productRulesApi.updateServiceIdRule(client, data)
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message || err)
    }
  },
)

export const deleteServiceIdRuleThunk = createAsyncThunk(
  'productRules/deleteServiceIdRule',
  async ({client, payload}, {rejectWithValue}) => {
    try {
      await productRulesApi.deleteServiceIdRule(client, payload)
      return payload
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message || err)
    }
  },
)
